"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSessionIdPlugin = exports.xssPatterns = void 0;
const cookies_1 = require("../lib/cookies");
const genericTrackingData_1 = require("../lib/genericTrackingData");
const SESSION_ID_KEY = 'tsidc';
const SESSION_EXPIRES_AT_KEY = 'tsideac';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24;
const SESSION_LENGTH_IN_MS = 60 * 60 * 1000;
const SESSION_STARTED_EVENT_NAME = 'Session Started';
let analyticsInstance = undefined;
exports.xssPatterns = [
    /<script.*?>.*?<\/script.*?>/i,
    /on\w+\s*=/i,
    /javascript:/i,
    /document\./i,
    /window\./i,
    /<iframe.*?>/i,
    /eval\(/i,
    /alert\(/i,
    /src\s*=\s*["']?javascript:.*?["']?/i,
    /&#x?[\da-fA-F]+;/i,
];
const createSessionIdPlugin = (sessionCookieDomain) => {
    const transform = (ctx) => {
        var _a, _b, _c, _d, _e, _f;
        try {
            const triggerSessionStarted = ((_a = ctx.event) === null || _a === void 0 ? void 0 : _a.event) !== SESSION_STARTED_EVENT_NAME;
            const sessionId = (_d = (_c = (_b = ctx.event) === null || _b === void 0 ? void 0 : _b.context) === null || _c === void 0 ? void 0 : _c.sessionId) !== null && _d !== void 0 ? _d : getSessionIdAndResetTimer(triggerSessionStarted);
            ctx.updateEvent('context.sessionId', sessionId);
            const traits = {};
            for (var key in (_e = ctx.event) === null || _e === void 0 ? void 0 : _e.traits) {
                const isXssPattern = exports.xssPatterns.some((pattern) => {
                    var _a, _b;
                    return pattern.test((_a = ctx.event) === null || _a === void 0 ? void 0 : _a.traits[key]) ||
                        pattern.test(decodeURIComponent((_b = ctx.event) === null || _b === void 0 ? void 0 : _b.traits[key]));
                });
                if (!isXssPattern) {
                    traits[key] = (_f = ctx.event) === null || _f === void 0 ? void 0 : _f.traits[key];
                }
            }
            ctx.updateEvent('traits', Object.assign(Object.assign({}, traits), { sessionId }));
        }
        catch (e) {
            console.log(e);
        }
        return ctx;
    };
    let sessionExpiresAtCache = '';
    let sessionIdCache = '';
    function getSessionIdAndResetTimer(triggerSessionStarted) {
        var _a, _b;
        let sessionId = (_a = (0, cookies_1.getCookie)(SESSION_ID_KEY)) !== null && _a !== void 0 ? _a : sessionIdCache;
        const sessionExpiresAt = (_b = (0, cookies_1.getCookie)(SESSION_EXPIRES_AT_KEY)) !== null && _b !== void 0 ? _b : sessionExpiresAtCache;
        if (!sessionId ||
            !sessionExpiresAt ||
            sessionExpiresAt < `${+new Date()}`) {
            sessionId = regenerateSessionId(triggerSessionStarted);
        }
        resetSessionCountdown();
        return sessionId;
    }
    function regenerateSessionId(triggerSessionStarted) {
        const sessionId = `${+new Date()}`;
        storeCookie(SESSION_ID_KEY, sessionId);
        sessionIdCache = sessionId;
        if (triggerSessionStarted) {
            setTimeout(() => {
                const properties = Object.assign(Object.assign({}, (0, genericTrackingData_1.getGenericTrackingData)()), { sessionId });
                analyticsInstance === null || analyticsInstance === void 0 ? void 0 : analyticsInstance.track(SESSION_STARTED_EVENT_NAME, properties);
            }, 0);
        }
        return sessionId;
    }
    function resetSessionCountdown() {
        sessionExpiresAtCache = `${+new Date() + SESSION_LENGTH_IN_MS}`;
        storeCookie(SESSION_EXPIRES_AT_KEY, sessionExpiresAtCache);
    }
    function storeCookie(cname, cvalue) {
        (0, cookies_1.setCookie)(cname, cvalue, {
            domain: sessionCookieDomain,
            maxAge: COOKIE_MAX_AGE_SECONDS,
            expires: new Date(Date.now() + COOKIE_MAX_AGE_SECONDS * 1000),
        });
    }
    return {
        name: 'Session Id',
        type: 'enrichment',
        version: '1.0.2',
        analyticsInstance: null,
        isLoaded: () => true,
        load: (ctx, instance) => {
            analyticsInstance = instance;
            return Promise.resolve();
        },
        track: transform,
        page: transform,
        identify: transform,
    };
};
exports.createSessionIdPlugin = createSessionIdPlugin;
//# sourceMappingURL=sessionId.js.map